<p-toast></p-toast>

<div class="grid">
    <div class="col-12">

        <p-card>
            <div class="mb-4">
                <h5 class="my-1">Commandes</h5>
                <span class="text-500">Gérez et consultez les commandes de matériel et d'équipement pour vos chantiers</span>
            </div>
            <div class="flex align-content-center justify-content-between flex-wrap gap-2 my-2">
                <div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="onSearch($event)"
                            placeholder="Recherche..." />
                    </span>
                </div>
                <div class="flex gap-2">
                    <p-selectButton 
                        [options]="viewOptions" 
                        [(ngModel)]="value" 
                        optionLabel="label" 
                        optionValue="value" />
                </div>
            </div>
                        <!-- List View -->
            <div *ngIf="value() === 'tableau'">
                <p-table #dt [value]="listeEmplacementsActifs" [columns]="selectedColumns" dataKey="emplacementId" tableStyleClass="tableNormale"
                    autoLayout="true" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [filterDelay]="0" [globalFilterFields]="['nom','code']">
                    <ng-template pTemplate="header" let-columns>
                        <tr>

                            <th pSortableColumn="code">
                                <div class="flex justify-content-between align-items-center">
                                    Numéro
                                    <p-sortIcon field="code"></p-sortIcon>
                                    <p-columnFilter type="text" field="code" display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>

                            <th pSortableColumn="nom">
                                <div class="flex justify-content-between align-items-center">
                                    Emplacement
                                    <p-sortIcon field="nom"></p-sortIcon>
                                    <p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
                                    </p-columnFilter>
                                </div>
                            </th>

                            <th style="min-width: 5rem"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-commande>
                        <tr [pContextMenuRow]="commande">
                            <!-- <td>
								<p-tableCheckbox [value]="Item"></p-tableCheckbox>
                            </td> -->

                            <td>
                                <a *ngIf="estAutorise('precommande_detail')" [routerLink]="'/commandes/' + commande.emplacementId">{{commande.code}}</a>
                                <span *ngIf="!estAutorise('precommande_detail')">{{commande.code}}</span>
     
                            </td>

                            <td>{{commande.nom}}</td>
                            <td>
                                <button *ngIf="estAutorise('precommande_detail')" pButton pRipple icon="pi pi-eye"
                                    class="p-button-success mr-2 boutonGrille"
                                    (click)="OuvrirDetailCommande(commande.emplacementId)"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3">Aucune pré-commande.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- Card View -->
            <div *ngIf="value() === 'cartes'">
                <div *ngIf="statsEmplacementsLoading" class="grid">
                    <div *ngFor="let skeleton of [1,2,3,4,5,6]" class="col-12 md:col-6 lg:col-4">
                        <p-card>
                            <p-skeleton height="1.5rem" styleClass="mb-1"></p-skeleton>
                            <p-skeleton height="1rem" styleClass="mb-2"></p-skeleton>
                            <div class="flex flex-column gap-2">
                                <div *ngFor="let item of [1,2,3,4,5,6,7]" class="flex justify-content-between align-items-center">
                                    <p-skeleton height="1rem" width="60%"></p-skeleton>
                                    <p-skeleton height="0.8rem" width="2rem"></p-skeleton>
                                </div>
                            </div>
                            <p-skeleton height="1.8rem" class="mt-2"></p-skeleton>
                        </p-card>
                    </div>
                </div>

                <div *ngIf="!statsEmplacementsLoading" class="grid">
                    <div *ngFor="let emplacement of listeEmplacementsFiltres" class="col-12 md:col-6 lg:col-4">
                        <p-card styleClass="h-full cursor-pointer" [ngClass]="{'hover:bg-blue-50': !themeService.isDarkMode()}" (click)="OuvrirDetailCommande(emplacement.emplacementId)">
                            <div class="flex justify-content-between gap-4 flex-wrap">
                                <div class="flex align-items-center gap-2" style="height: fit-content;">
                                    <i class="pi pi-map-marker text-xl"></i>
                                    <div>
                                        <h6 class="mb-1">{{ emplacement.code }}</h6>
                                        <p class="text-600 text-sm mb-0">{{ emplacement.nom }}</p>
                                    </div>
                                </div>
                                <div class="flex flex-column gap-1">
                                    <div *ngFor="let status of getStatusList()">
                                        <div *ngIf="emplacement[status.key] > 0" class="flex align-items-center justify-content-between gap-2">
                                            <span class="status-label">{{ status.label }}</span>
                                            <span class="statut {{ status.cssClass }}">
                                                {{ emplacement[status.key] || 0 }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-card>
                    </div>
                </div>

                <div *ngIf="!statsEmplacementsLoading && listeEmplacementsFiltres.length === 0" class="text-center py-4">
                    <i class="pi pi-info-circle text-6xl text-400 mb-3"></i>
                    <p class="text-600">
                        <span *ngIf="searchTerm">Aucun résultat trouvé pour "{{ searchTerm }}".</span>
                        <span *ngIf="!searchTerm">Aucune pré-commande disponible.</span>
                    </p>
                </div>
            </div>
        </p-card>
    </div>


</div>